import { Component } from "@angular/core";
import { GlobalSettingsVM, CounsellingTopicVM, ReasonForMedicationVM, CountryVM, NationalityVM, WhoAmIVM, LanguageVM } from "../../models";
import { FormGroup, FormArray, FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BaseHtmlHelperComponent } from "./base.htmlhelper.component";
import { TimeZoneInfoVM } from "../../models/TimeZoneInfoVM";

export class BaseComponent extends BaseHtmlHelperComponent {

  public globalSettings: GlobalSettingsVM;
  public me: WhoAmIVM;
  public myForm: FormGroup;
  public counsellingTopicList: CounsellingTopicVM[];
  public reasonsForMedicationList: ReasonForMedicationVM[];
  public countryList: CountryVM[];
  public stateList: string[];
  public nationalityList: NationalityVM[];
  public languageList: LanguageVM[];

  constructor(private baseRoute: ActivatedRoute) {
    super();

    if (this.baseRoute.snapshot.data['globalSettings'] != null) {
      this.globalSettings = this.baseRoute.snapshot.data['globalSettings'];
    }

    if (this.baseRoute.snapshot.data['whoAmI']) {
      this.me = this.baseRoute.snapshot.data['whoAmI'];
    }

    if (this.baseRoute.snapshot.data['countryList'] != null) {
      this.countryList = this.baseRoute.snapshot.data['countryList'];
    }

    if (this.baseRoute.snapshot.data['stateList'] != null) {
      this.stateList = this.baseRoute.snapshot.data['stateList'];
    }

    if (this.baseRoute.snapshot.data['nationalityList'] != null) {
      this.nationalityList = this.baseRoute.snapshot.data['nationalityList'];
    }

    if (this.baseRoute.snapshot.data['languageList'] != null) {
      this.languageList = this.baseRoute.snapshot.data['languageList'];
    }

    if (this.baseRoute.snapshot.data['counsellingTopicList'] != null) {
      this.counsellingTopicList = this.baseRoute.snapshot.data['counsellingTopicList'];
    }

    this.emitDisplayLoadingDialog(false);
    window.scrollTo(0, 0);
  }

  markAsTouched(group: FormGroup | FormArray) {
    Object.keys(group.controls).map((field) => {
      const control = group.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAsTouched(control);
      }
    });
  }

  equalCountry(n1: CountryVM, n2: CountryVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalNationality(n1: NationalityVM, n2: NationalityVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalCounsellingTopic(n1: CounsellingTopicVM, n2: CounsellingTopicVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalLanguage(n1: LanguageVM, n2: LanguageVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalTimeZone(n1: TimeZoneInfoVM, n2: TimeZoneInfoVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.zoneName === n2.zoneName;
  }

}
